export enum EPromoLandings {
    MOBILE = 'mobile',
    MOBILE_NEW = 'cloud-mobile-new',
    FILES_TRANSFER = 'files-transfer',
    PHOTO = 'photo',
    PHOTO_NEW = 'photo-new',
    PRO = 'pro',
    DOBRO = 'dobro',
    EDITOR = 'editor',
    CLOUD_WEB = 'cloudWeb',
    PARTNERS = 'partners',
    NEW_YEAR = 'new-year',
    EVENTS = 'events',
    FILES = 'cloud-files',
    PRESENT = 'present',
    NINE_MAY = 'cloud-promo-9may',
    MAIL = 'promo-mail',
    LOGIN = 'promo-login',
    PDF = 'cloud-promo-pdf-redaktor',
    DOCS = 'cloud-promo-docs',
    CLOUD_NEW = 'cloud-new',
    CLOUD_SECURITY = 'cloud-security',
    CLOUD_BOOK = 'cloud-promo-book',
    CLOUD_PROMO_REACH_CAMPAIGN = 'cloud-promo-reach-campaign',
    ClOUD_SAVE_OF_MEMORIES = 'cloud-save-of-memories',
    CLOUD_SUMMER_COLLAGE = 'cloud-promo-summer-collage',
}

export const PROMO_LANDING_TYPE = {
    'promo/files': EPromoLandings.FILES_TRANSFER,
    'promo/partners': EPromoLandings.PARTNERS,
    'promo/photo': EPromoLandings.PHOTO_NEW,
    'promo/pro': EPromoLandings.PRO,
    'promo/present': EPromoLandings.PRESENT,
    promocodes: EPromoLandings.PRESENT,
    'promo/9may': EPromoLandings.NINE_MAY,
    'promo/mail': EPromoLandings.MAIL,
    'promo/login': EPromoLandings.LOGIN,
    'promo/pdf-redaktor': EPromoLandings.PDF,
    'promo/docs': EPromoLandings.DOCS,
    'promo/dobro': EPromoLandings.DOBRO,
    'promo/online-redaktor-dokumentov': EPromoLandings.EDITOR,
    'promo/newyear': EPromoLandings.NEW_YEAR,
    'promo/events': EPromoLandings.EVENTS,
    mobile: EPromoLandings.MOBILE,
    promo: EPromoLandings.CLOUD_WEB,
    'promo/cloud-files': EPromoLandings.FILES,
    'promo/summer': EPromoLandings.CLOUD_NEW,
    'promo/security': EPromoLandings.CLOUD_SECURITY,
    'promo/book': EPromoLandings.CLOUD_BOOK,
    'promo/memories': EPromoLandings.ClOUD_SAVE_OF_MEMORIES,
    'promo/summer_collage': EPromoLandings.CLOUD_SUMMER_COLLAGE,
};

export const PROMO_REG_EXP = new RegExp(`^/(${Object.keys(PROMO_LANDING_TYPE).join('|')})/?$`);

export enum EReactLandings {
    QUOTA = 'quota',
    QUOTA_IOS = 'quota/ios',
    QUOTA_ANDROID = 'quota/android',
    QUOTA_PARTNER = 'quota/partner',
    QUOTA_TARIFFS = 'quota/tariffs',
    QUOTA_TARIFFS_NEW = 'quota/tariffs/new',
    QUOTA_PRO = 'quota-pro',
    UPLOADER = 'uploader',
    BUY = 'buy',
    CHOICE = 'choice',
    // tempexp_17127-next-line
    BUY_DISABLE_ADS = 'buy/disable-ads',
    BUY_MSP_PRO = 'buy/msp-pro',
    HAPPY_BIRTHDAY_CLOUD = 'happybirthdaycloud',
    FAMILY = 'family',
}

export const REACT_LANDING_TYPE = {
    'promo/quota': EReactLandings.QUOTA,
    'promo/quota/ios': EReactLandings.QUOTA_IOS,
    'promo/quota/android': EReactLandings.QUOTA_ANDROID,
    'promo/quota/partner': EReactLandings.QUOTA_PARTNER,
    'promo/quota/tariffs': EReactLandings.QUOTA_TARIFFS,
    'promo/quota/tariffs/new': EReactLandings.QUOTA_TARIFFS_NEW,
    'promo/quota-pro': EReactLandings.QUOTA_PRO,
    uploader: EReactLandings.UPLOADER,
    buy: EReactLandings.BUY,
    choice: EReactLandings.CHOICE,
    // tempexp_17127-next-line
    'buy/disable-ads': EReactLandings.BUY_DISABLE_ADS,
    'buy/msp-pro': EReactLandings.BUY_MSP_PRO,
    'promo/happybirthdaycloud': EReactLandings.HAPPY_BIRTHDAY_CLOUD,
    'promo/family': EReactLandings.FAMILY,
};

export const REACT_LANDINGS_REG_EXP = new RegExp(`^/(${Object.keys(REACT_LANDING_TYPE).join('|')})/?$`);
